import { Button, Form } from '@mairistem/composants';

import iconEncaisser from '@/assets/images/icon_encaisser_white.svg';

interface ComptantActionsProps {
  encaisserDisabled: boolean;
  onReinitialiser: () => void;
  onEncaisser: () => void;
}

const ComptantActions = ({
  encaisserDisabled,
  onReinitialiser,
  onEncaisser,
}: ComptantActionsProps) => (
  <Form.Group className="comptant-actions">
    <Button
      basic
      type="button"
      icon="close"
      content="Réinitialiser"
      data-testid="comptant-reinitialiser"
      onClick={onReinitialiser}
    />
    <Button
      positive
      type="button"
      data-testid="comptant-encaissement"
      disabled={encaisserDisabled}
      style={{ marginLeft: '1em' }}
      onClick={onEncaisser}
    >
      <img src={iconEncaisser} alt="" className="comptant-icon-encaisser" />
      Encaisser
    </Button>
  </Form.Group>
);

export default ComptantActions;
